export const routes = [
  {
    path: '/changelog',
    name: '/changelog',
    component: () => import('/home/runner/work/spatialwalk-model-eval/spatialwalk-model-eval/src/client/pages/changelog.vue'),
    /* no children */
  },
  {
    path: '/corpus',
    /* internal name: '/corpus' */
    /* no component */
    children: [
      {
        path: '',
        name: '/corpus/',
        component: () => import('/home/runner/work/spatialwalk-model-eval/spatialwalk-model-eval/src/client/pages/corpus/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/evaluation-assets',
    /* internal name: '/evaluation-assets' */
    /* no component */
    children: [
      {
        path: '',
        name: '/evaluation-assets/',
        component: () => import('/home/runner/work/spatialwalk-model-eval/spatialwalk-model-eval/src/client/pages/evaluation-assets/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/evaluation-management',
    /* internal name: '/evaluation-management' */
    /* no component */
    children: [
      {
        path: '',
        name: '/evaluation-management/',
        component: () => import('/home/runner/work/spatialwalk-model-eval/spatialwalk-model-eval/src/client/pages/evaluation-management/index.vue'),
        /* no children */
      },
      {
        path: ':runId',
        name: '/evaluation-management/[runId]',
        component: () => import('/home/runner/work/spatialwalk-model-eval/spatialwalk-model-eval/src/client/pages/evaluation-management/[runId].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/evaluation-share',
    /* internal name: '/evaluation-share' */
    /* no component */
    children: [
      {
        path: ':shareId',
        name: '/evaluation-share/[shareId]',
        component: () => import('/home/runner/work/spatialwalk-model-eval/spatialwalk-model-eval/src/client/pages/evaluation-share/[shareId].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/export',
    /* internal name: '/export' */
    /* no component */
    children: [
      {
        path: '',
        name: '/export/',
        component: () => import('/home/runner/work/spatialwalk-model-eval/spatialwalk-model-eval/src/client/pages/export/index.vue'),
        /* no children */
      },
      {
        path: 'components',
        /* internal name: '/export/components' */
        /* no component */
        children: [
          {
            path: 'UsageGuide',
            name: '/export/components/UsageGuide',
            component: () => import('/home/runner/work/spatialwalk-model-eval/spatialwalk-model-eval/src/client/pages/export/components/UsageGuide.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/results',
    /* internal name: '/results' */
    /* no component */
    children: [
      {
        path: '',
        name: '/results/',
        component: () => import('/home/runner/work/spatialwalk-model-eval/spatialwalk-model-eval/src/client/pages/results/index.vue'),
        /* no children */
      },
      {
        path: ':taskId',
        name: '/results/[taskId]',
        component: () => import('/home/runner/work/spatialwalk-model-eval/spatialwalk-model-eval/src/client/pages/results/[taskId].vue'),
        /* no children */
      },
      {
        path: 'mock',
        /* internal name: '/results/mock' */
        /* no component */
        children: [
          {
            path: 'list',
            name: '/results/mock/list',
            component: () => import('/home/runner/work/spatialwalk-model-eval/spatialwalk-model-eval/src/client/pages/results/mock/list.vue'),
            /* no children */
          },
          {
            path: 'preview',
            name: '/results/mock/preview',
            component: () => import('/home/runner/work/spatialwalk-model-eval/spatialwalk-model-eval/src/client/pages/results/mock/preview.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/test-ground',
    /* internal name: '/test-ground' */
    /* no component */
    children: [
      {
        path: '',
        name: '/test-ground/',
        component: () => import('/home/runner/work/spatialwalk-model-eval/spatialwalk-model-eval/src/client/pages/test-ground/index.vue'),
        /* no children */
      },
      {
        path: 'rating',
        name: '/test-ground/rating',
        component: () => import('/home/runner/work/spatialwalk-model-eval/spatialwalk-model-eval/src/client/pages/test-ground/rating.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/test-ground-ng',
    /* internal name: '/test-ground-ng' */
    /* no component */
    children: [
      {
        path: '',
        name: '/test-ground-ng/',
        component: () => import('/home/runner/work/spatialwalk-model-eval/spatialwalk-model-eval/src/client/pages/test-ground-ng/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/tracker-fit',
    /* internal name: '/tracker-fit' */
    /* no component */
    children: [
      {
        path: '',
        name: '/tracker-fit/',
        component: () => import('/home/runner/work/spatialwalk-model-eval/spatialwalk-model-eval/src/client/pages/tracker-fit/index.vue'),
        /* no children */
      },
      {
        path: 'view',
        name: '/tracker-fit/view',
        component: () => import('/home/runner/work/spatialwalk-model-eval/spatialwalk-model-eval/src/client/pages/tracker-fit/view.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/video-eval',
    /* internal name: '/video-eval' */
    /* no component */
    children: [
      {
        path: '',
        name: '/video-eval/',
        component: () => import('/home/runner/work/spatialwalk-model-eval/spatialwalk-model-eval/src/client/pages/video-eval/index.vue'),
        /* no children */
      }
    ],
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

